<!--
  File name: Drawer.vue
  Program Description:
    - This component displays the navigation drawer used in the system.
    - It is being rendered in the Dashboard.vue component.

-->

<template>
  <v-navigation-drawer
    v-model="showDrawer"
    app
    stateless
    permanent
    width="300px"
    :style="`background-color: ${$metaData.app.login.background}`"
  >
    <v-card
      class="pt-2 pb-2"
      elevation="0"
    >
      <v-img
        class="mx-auto"
        :src="`${$metaData.app.logo}`"
        height="75%"
        width="75%"
      />
    </v-card>
    <v-list-item v-if="title">
      <v-list-item-content>
        <v-list-item-title
          class="title"
          :class="title.length < 4 ? 'text-uppercase' : 'text-capitalize'"
        >
          {{ title }}
        </v-list-item-title>
        <v-list-item-subtitle v-if="subtitle">
          {{ subtitle }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list>
      <slot />
    </v-list>
  </v-navigation-drawer>
</template>

<script>

export default {
  name: 'Drawer',
  props: {
    show: Boolean,
    title: { type: String, default: undefined },
    subtitle: { type: String, default: undefined }
  },
  computed: {
    showDrawer: {
      get: function () {
        return this.show
      },
      set () { }
    }
  }
}
</script>

<style scoped>
#drawer-menu >>> {
  max-height: 100% !important;
}
</style>
